import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListingNewComponent } from './listing-new.component';
import { FontAwesomeModule } from '../../modules/font-awesome.module';
import { DirectivesModule } from '../../modules/directives.module';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '../../modules/material.module';
import { AddComponent } from './components/add/add.component';
import { SortComponent } from './components/sort/sort.component';
import { FilterComponent } from './components/filter/filter.component';
import { ListModule } from '../listing/list/list.module';
import { AsBoxModule } from '../../external-libraries/ngx-advanced-searchbox/src/public_api';
import { SharedModule } from '../../modules/shared.module';
import { RouterModule } from '@angular/router';
import { ActionsComponent } from './components/actions/actions.component';
import { RebuildSearchDatabaseOptionComponent } from '../listing/rebuild-search-database/rebuild-search-database.component';
import { BulkUpdateButtonComponent } from './components/dialog/bulk-update-button.component';
import { BarcodeOptionComponent } from './components/options/barcode/barcode.component';
import { OptionsModule } from './components/options/options.module';
import { PaginationModule } from './components/pagination/pagination.module';

@NgModule({
  declarations: [
    ListingNewComponent,
    AddComponent,
    SortComponent,
    FilterComponent,
    ActionsComponent,
    RebuildSearchDatabaseOptionComponent,
    BulkUpdateButtonComponent,
    BarcodeOptionComponent,
  ],
  imports: [
    CommonModule,
    SharedModule.forRoot(),
    FontAwesomeModule,
    DirectivesModule,
    TranslateModule,
    MaterialModule,
    ListModule,
    AsBoxModule.forRoot(),
    RouterModule,
    OptionsModule,
    PaginationModule
  ],
  exports: [
    ListingNewComponent,
    ActionsComponent
  ],
})
export class ListingNewModule { }
